<template>
  <section class ="custom-config-container">
    <div class="preview-wrap">
      <el-tabs v-model="activeTab">
        <el-tab-pane label='title' name='1'>
          <div class="src-wrap">
            <el-input v-model="realSrc"></el-input>
            <el-button type="primary" @click="handleClickOpen">打开网址</el-button>
          </div>
          <div class="iframe-wrap">
            <iframe
              id="myIframe"
              :src="src"
              frameborder="0"
              security="restricted"
              @load='iframeLoad'></iframe>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class='funs-wrap'>
        <div class="left">
          <el-link :underline="false">
            <jee-icon iconClass="jia"/>增加字段
          </el-link>
          <el-link :underline="false">
            <jee-icon iconClass="delete"/>清空字段</el-link>
          <el-link :underline="false">
            <jee-icon iconClass="shezhiquzhi"/>高级设置</el-link>
        </div>
        <div class="right">
          <el-link :underline="false">
            <jee-icon iconClass="xuanzhejiantou"/>选择列表</el-link>
          <el-link :underline="false">
            <jee-icon iconClass="caijiyeshu"/>采集页数</el-link>
          <el-link :underline="false">
            <jee-icon iconClass="fenyeshezhi"/>分页设置</el-link>
          <el-link :underline="false">
            <jee-icon iconClass="caijiliebiao"/>采集列表
          </el-link>
          <!-- caijidanye -->
          <el-link :underline="false" v-if="tagName === 'a'" @click="handleClickLink">
            <jee-icon iconClass="jia"/>深入链接采集</el-link>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'CustomConfigContainer',
  data () {
    return {
      realSrc: 'http://www.gov.cn/xinwen/2019-07/25/content_5414726.htm',
      src: '/test2.html',
      xpath: '',
      tagName: '',
      activeTab: '1'
    }
  },
  methods: {
    handleClickOpen () {

    },
    handleClickLink () {
    },
    onClick (e) {
      e.stopPropagation()
      e.preventDefault()
      // 获取xpath
      var readXPath = function f (element) {
        // /html/body/div[3]/div[1]/div[1]/div[2]/p[2]
        const body = window.document.getElementById('myIframe').contentWindow.document.body
        if (element.id !== '') { // 判断id属性，如果这个元素有id，则显 示//*[@id="xPath"]  形式内容
          // eslint-disable-next-line no-useless-escape
          return '//*[@id=\"' + element.id + '\"]'
        }
        // 这里需要需要主要字符串转译问题，可参考js 动态生成html时字符串和变量转译（注意引号的作用）
        if (element === body) { // 递归到body处，结束递归
          return '/html/' + element.tagName.toLowerCase()
        }
        var ix = 1 // 在nodelist中的位置，且每次点击初始化
        var siblings = element.parentNode.childNodes// 同级的子元素

        for (var i = 0, l = siblings.length; i < l; i++) {
          var sibling = siblings[i]
          // 如果这个元素是siblings数组中的元素，则执行递归操作
          if (sibling === element) {
            return f(element.parentNode) + '/' + element.tagName.toLowerCase() + '[' + (ix) + ']'
            // 如果不符合，判断是否是element元素，并且是否是相同元素，如果是相同的就开始累加
          } else if (sibling.nodeType === 1 && sibling.tagName === element.tagName) {
            ix++
          }
        }
      }
      const xpath = readXPath(e.target)
      console.log(xpath)
      this.xpath = xpath
      this.tagName = e.target.tagName.toLowerCase()
    },
    onMouseMove (e) {
      e.stopPropagation()
      e.target.style.backgroundColor = 'yellow'
    },
    onMouseleave (e) {
      e.stopPropagation()
      e.target.style.backgroundColor = ''
    },
    iframeLoad (e) {
      const iframe = window.document.getElementById('myIframe')
      iframe.contentWindow.document.body.addEventListener('click', this.onClick)
      iframe.contentWindow.document.body.addEventListener('mousemove', this.onMouseMove)
      const that = this
      const registerEvent = function r (element) {
        if (element.nodeType === 1) {
          element.onmouseout = that.onMouseleave
          if (element.childNodes instanceof Array && element.childNodes.length) {
            for (var i = 0, l = element.childNodes.length; i < l; i++) {
              r(element.childNodes[i])
            }
          }
        }
      }
      registerEvent(iframe.contentWindow.document.body)
    }
  }
}
</script>
<style lang="scss">
.custom-config-container{
  .iframe-wrap{
    margin-top: 20px;
    overflow: auto;
    height: 360px;
    border-radius: 4px;
    border: 1px solid #e8e8e8;

    iframe{
      width: 100%;
      height: 100%;
    }
  }
}
</style>
